import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}

const ImageGenerationModal = ({
  open,
  onClose,
  loading,
  error,
  onRetry,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      onKeyDown={(e) => e.stopPropagation()}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AutoAwesomeIcon sx={{ color: "#5048E5" }} />
          <Typography variant="h6">Generate Images</Typography>
        </Box>
        {!loading && (
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>
        {/* Loading state */}
        {loading && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress sx={{ color: "#5048E5" }} />
            <Typography variant="body1" color="text.secondary">
              Analyzing article and generating images...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This may take a minute
            </Typography>
          </Box>
        )}

        {/* Error state */}
        {!loading && error && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: 6,
              gap: 2,
            }}
          >
            <Typography variant="body1" color="error">
              {error}
            </Typography>
            <Button variant="outlined" onClick={onRetry}>
              Try Again
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImageGenerationModal;
